<template>
  <div>
    <section class="banner">
      <div class="col-12">
          <div class="accordion" id="main-accordion2">    
            <div class="accordion-item">
                  <div class="accordion-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#accordion-collapse" aria-expanded="false"
                          aria-controls="accordion-collapse">
                          Data Features
                      </button>
                    </div>
                    <div id="accordion-collapse" class="accordion-collapse collapse"
                        aria-labelledby="accordion-heading"
                        data-bs-parent="#main-accordion2">
                        <div class="accordion-body">
                          <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                              <h4>Models</h4>
                              <ul>
                                <li><b>B16:</b> B16 F10 melanoma</li>
                                <li><b>CT26:</b> CT26 colon cancer</li>
                                <li><b>KPC:</b> KPC pancreatic cancer</li>
                                <li><b>LLC:</b> Lewis Lung cell carcinoma</li>
                                <li><b>MC38:</b> MC38 colon carcinoma</li>
                                <li><b>Panc02:</b> Panc02 pancreatic cancer</li>
                                <li><b>Renca:</b> Renca renal cell carcinoma</li>
                                <li><b>YUMMER:</b> YUMMER melanoma</li>

                              </ul>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                              <h4>Conditions</h4>
                              <ul>
                                <li><b>Input:</b>  library representation at the time of tumor implantation</li>
                                <li><b>Output:</b>  in vitro culture for 12-18 days</li>
                                <li><b>NSG:</b> tumors isolated from immunodeficient control mice 12-18 days following tumor implantation</li>
                                <li><b>WT:</b> tumors isolated from immunocompetent, wild-type untreated mice 12-18 days following tumor implantation</li>
                                <li><b>ICB:</b> tumors isolated from immunotherapy-treated wild-type mice 12-18 days following tumor implantation</li>
                              </ul>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                              <h4>Screen Libraries</h4>
                              <ul>
                                <li><b>Genome:</b> (18,748 genes, see Dubrot, Du et al, Nature Immunology 2022)</li>             
                                <li><b>Chromatin Regulators:</b> (936 genes, see <a target="_blank" href="https://www.nature.com/articles/s41586-021-03520-4">paper</a>)</li>
                                <li><b>Subgenome: </b> (2,368 genes, see <a target="_blank" href="https://www.nature.com/articles/nature23270">paper</a>)</li>
                              </ul>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
          </div>
        </div>
    </section>

    <DataPortal></DataPortal>
  </div>
</template>

 <script>
import DataPortal from '../components/DataPortal.vue'

    
export default {
    components: { DataPortal }
}

</script>



